import React from 'react';
import { routes } from 'constants/config';
import { Icon, Card } from 'components/ui';
import Text from 'components/shared/Text';

const scenarioTypeStrings = {
  screen_recording: t(
    'practice.on_demand_practice.response_types.screen_recording',
  ),
  audio_recording: t(
    'practice.on_demand_practice.response_types.audio_recording',
  ),
  webcam_recording: t(
    'practice.on_demand_practice.response_types.webcam_recording',
  ),
  written_response: t(
    'practice.on_demand_practice.response_types.written_response',
  ),
  conversation: t('practice.on_demand_practice.response_types.conversation'),
};

const COVER_IMAGE_ICONS = {
  screen_recording: 'laptop',
  audio_recording: 'audio',
  webcam_recording: 'person',
  written_response: 'paper',
  conversation: 'chat',
};

const SCENARIO_TYPE_ICONS = {
  screen_recording: 'laptop_outlined',
  audio_recording: 'microphone_outlined',
  webcam_recording: 'webcam_outlined',
  written_response: 'keyboard_outlined',
  conversation: 'chat_outlined',
};

const OnDemandPracticeCard = ({ scenario }) => (
  <Card
    useRouter
    url={routes.ON_DEMAND_PRACTICE.LEARNING.SHOW(scenario.id)}
    className="OnDemandPracticeCard"
  >
    <div className="OnDemandPracticeCard-image CustomColor--backgroundColor d-f ai-c jc-c">
      <Icon className="fz-64" name={COVER_IMAGE_ICONS[scenario.scenarioType]} />
    </div>
    <Card.Content padding="medium" className="OnDemandPracticeCard-content">
      <div>
        <Text className="OnDemandPracticeCard-title mb-12" lines={3}>
          {scenario.title}
        </Text>
        <Text className="OnDemandPracticeCard-description" lines={3}>
          {scenario.description}
        </Text>
      </div>
      <div className="OnDemandPracticeCard-footer">
        <Icon
          className="fz-18"
          name={SCENARIO_TYPE_ICONS[scenario.scenarioType]}
        />
        <span className="ls-u fw-600 p-3-10 fz-12 tt-n">
          {scenarioTypeStrings[scenario.scenarioType]}
        </span>
      </div>
    </Card.Content>
  </Card>
);
export default OnDemandPracticeCard;
